import { SortDirection } from '@air/api/types';

import { makeActiveTableColumnFromOption } from '~/components/TableView/tableColumnWidthsUtils';
import { type ActiveTableColumn } from '~/components/TableView/types';
import { ConfigVisibilityToggleType } from '~/constants/configViews';
import { getConfigFieldLabel } from '~/constants/SortFieldsMap';
import { type ConfigViewOption } from '~/store/configViews/types';

const FIELD_NAMES = [
  ConfigVisibilityToggleType.dateCreated,
  ConfigVisibilityToggleType.dateModified,
  ConfigVisibilityToggleType.ext,
  ConfigVisibilityToggleType.size,
  ConfigVisibilityToggleType.type,
  ConfigVisibilityToggleType.resolution,
  ConfigVisibilityToggleType.tagCount,
  ConfigVisibilityToggleType.boardCount,
] as const;

const toOption = (fieldName: ConfigVisibilityToggleType): ConfigViewOption => ({
  customFieldId: undefined,
  derivedId: fieldName,
  fieldName,
  isCurrentSortedOption: false,
  isCustomField: false,
  isVisible: true,
  label: getConfigFieldLabel(fieldName),
  sortDirection: SortDirection.desc,
  supports: [],
});

/** Columns this list always shows. Empty `supports` keeps the headers from sorting the shared view. */
export const WORKSPACE_AGENT_ASSET_LIST_TABLE_OPTIONS: ConfigViewOption[] = FIELD_NAMES.map(toOption);

/** Widths for the name column, the fixed fields, and the row actions. Scoped off the shared table. */
export const WORKSPACE_AGENT_ASSET_LIST_ACTIVE_COLUMNS: ActiveTableColumn[] = [
  makeActiveTableColumnFromOption('title', false),
  makeActiveTableColumnFromOption('buttons', false),
  ...WORKSPACE_AGENT_ASSET_LIST_TABLE_OPTIONS.map((option) => makeActiveTableColumnFromOption(option.fieldName, false)),
];

export const WORKSPACE_AGENT_ASSET_LIST_TABLE_WIDTH_SCOPE = 'workspace-agent-asset-list';
